module.exports = "<div id=\"browse\">\n  <div ui-view></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/browse/browse.html
// module id = 804
// module chunks = 1